// extracted by mini-css-extract-plugin
module.exports = {"priceData":"Price_priceData__h_UWS"};